function coinCombinationToArray(comb) {
	const list = [];
	for (const c of comb) list.push(...Array(c.amount).fill(c.coin));
	return list;
}
export { coinCombinationToArray };

//# sourceMappingURL=index245.js.map